<div class="full-screen">
  <div class="assign-driver-page" *ngIf="tripDetails">

    <!-- Page Header -->
    <div class="page-header pl-0" *ngIf="tripDetails">
      <button pButton type="button" icon="pi pi-arrow-left" class="p-button-text back-button pl-0 m-0"
        (click)="goBack()"></button>
      <h2 class="page-title" *ngIf="!tripDetails.driverInfo?.firstName" translate>label_assign_driver_to_journey</h2>
      <h2 class="page-title" *ngIf="tripDetails.driverInfo?.firstName" translate>label_reassign_driver_to_journey</h2>
    </div>
    <!-- Trip Details Accordion -->
    <div class="trip-details-section mb-2" *ngIf="tripDetails">
      <div class="accordion-header" (click)="toggleAccordion()">
        <div class="trip-info">
          <div class="trip-time">{{ tripDetails.tourBookingInfo.pickupDateTime | date:'hh:mm a MM/dd/yyyy' }}</div>
          <div class="trip-id">
            <span translate>label_booking_ID </span> <span class="trip-value">{{
              tripDetails.tourBookingInfo.tripId }}</span>
            <span class="pl-1 pr-2">|</span>
            <span translate>label_assigned_driver</span>
            <span class="trip-value">
              {{ tripDetails.driverInfo?.firstName? tripDetails.driverInfo?.firstName +'
              '+tripDetails.driverInfo?.lastName :'NA' }}
            </span>
            <span class="pl-1 pr-2">|</span>
            <span translate>label_vehicle</span><span class="trip-value">
              {{ tripDetails.vehicleInfo?.vehicleNumber? tripDetails.vehicleInfo?.vehicleNumber +' (' + tripDetails.vehicleInfo?.vehicleType + ')' : 'NA' }}
            </span>
          </div>
        </div>
        <div class="trip-status-wrapper">
          <span class="trip-status status-confirmed">{{ tripDetails.tourBookingInfo.tourStatusString }}</span>
          <i class="fa" [ngClass]="isAccordionOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>
      </div>

      <div class="accordion-content" *ngIf="isAccordionOpen">
        <div class="grid">
          <!-- Passenger Details Column 1 -->
          <div class="col-12 md:col-4">
            <h3 class="section-title" translate>label_passenger_details</h3>
            <div class="detail-row">
              <span class="detail-label" translate>label_name</span>
              <span class="detail-value">{{ tripDetails.passengerInfo.firstName }} {{ tripDetails.passengerInfo.lastName
                }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label" translate>label_phone_number</span>
              <span class="detail-value">{{ tripDetails.passengerInfo.numCountryCode }} {{
                tripDetails.passengerInfo.phoneNum }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label" translate>label_email_id</span>
              <span class="detail-value">{{ tripDetails.passengerInfo.email }}</span>
            </div>
            
            <div class="detail-row">
              <span class="detail-label" translate>label_note</span>
              <span class="detail-value">{{ tripDetails.tourBookingInfo.note? tripDetails.tourBookingInfo.note:'NA' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label" translate>label_booking_for</span>
              <span class="detail-value">{{ tripDetails.tourBookingInfo.bookingForSomeoneElse === true? 'Someone Else':'Self' 
                }}</span>
            </div>
            @if(tripDetails.tourBookingInfo.bookingForSomeoneElse === true) {
            <div class="detail-row">
              <span class="detail-label" translate>label_name</span>
              <span class="detail-value">{{ tripDetails.tourBookingInfo.gFirstName?
                tripDetails.tourBookingInfo.gFirstName:'NA' }} {{ tripDetails.tourBookingInfo.gLastName?
                tripDetails.tourBookingInfo.gLastName:'NA' }}
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label" translate>label_phone_no</span>
              <span class="detail-value">{{ tripDetails.tourBookingInfo.gPhoneNum?
                tripDetails.tourBookingInfo.gNumCountryCode+' '+tripDetails.tourBookingInfo.gPhoneNum:'NA'
                }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label" translate>label_email_id</span>
              <span class="detail-value">{{ tripDetails.tourBookingInfo.gEmail?
                tripDetails.tourBookingInfo.gEmail:'NA' }}</span>
            </div>
          }
          </div>

          <!-- Booking Details Column 2 -->
          <div class="col-12 md:col-4">
            <h3 class="section-title" translate>label_booking_details</h3>
            <div class="detail-row">
              <span class="detail-label" translate>label_booking_type</span>
              <span class="detail-value">{{ tripDetails.tourBookingInfo.rideType }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label" translate>label_trip_fare</span>
              <span class="detail-value">
                {{ tripDetails.tourBookingInfo.bookingCreatedBy }}
                {{ (tripDetails.invoiceInfo?.id ? tripDetails.invoiceInfo?.grandTotalString : tripDetails.tourBookingInfo.tourStatus !== cancelledTrip && tripDetails.tourBookingInfo?.tourStatus !== expiredTrip)? tripDetails.estimatesInfo.grandTotalString : ''}}
              
              </span>
            </div>
            <div class="detail-row hidden">
              <span class="detail-label" translate>label_service_type</span>
              <span class="detail-value">{{ tripDetails.tourBookingInfo.serviceType }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label" translate>label_vehicle_type_header</span>
              <span class="detail-value">
                {{ tripDetails.vehicleTypeInfo?.vehicleType ? tripDetails.vehicleTypeInfo.vehicleType : 'NA' }}</span>
            </div>
          </div>

          <!-- Passenger Details (Locations) Column 3 -->
          <div class="col-12 md:col-4">
            <h3 class="section-title" translate>label_location_details</h3>
            <div class="detail-row">
              <span class="detail-label" translate>label_pickup_location</span>
              <span class="detail-value">{{ tripDetails.tourBookingInfo.pickupLocationName }}</span>
            </div>

            <div *ngIf="tripDetails.tourBookingInfo.bookingDropPoints">
              <div class="detail-row"
                *ngFor="let bookingDropPoints of tripDetails.tourBookingInfo.bookingDropPoints;let index = index">
                <span class="detail-label" translate>Stop {{index + 1}}</span>
                <span class="detail-value">{{ bookingDropPoints.dropAddress }}</span>
              </div>
            </div>
            <div class="detail-row">
              <span class="detail-label" translate>label_drop_off_location</span>
              <span class="detail-value">{{ tripDetails.tourBookingInfo.dropLocationName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Assign Driver Section -->
    <div class="assign-driver-section">
      <!-- <h2 class="section-header px-2" translate>label_driver_list</h2> -->

      <!-- Search Input -->
      <!-- <div class="search-wrapper position-relative mb-3" style="max-width: 400px;">
      <i class="fa fa-search search-icon"></i>
      <input 
        type="text" 
        class="search-input" 
        [(ngModel)]="searchText"
        (keyup.enter)="onFilterChange()"
        placeholder="Search by driver name">
    </div> -->

      <!-- Filters -->
      <div class="filters-row m-0 px-2 pb-0">
        <div class="grid">
          <!-- <div class="col-12 md:col-2">
        <div class="form-field">
          <label class="filter-label" translate>label_vehicle_type_header</label>
          <p-dropdown 
            [options]="vehicleTypeOptions" 
            [(ngModel)]="selectedVehicleType"
            [style]="{'width': '100%'}"
            placeholder="All">
          </p-dropdown>
        </div>
      </div> -->
          <!--       
      <div class="col-12 md:col-2">
        <div class="form-field">
          <label class="filter-label" translate>label_weekly_off</label>
          <p-dropdown 
            [options]="weeklyOffOptions" 
            [(ngModel)]="selectedWeeklyOff"
            [style]="{'width': '100%'}"
            placeholder="All">
          </p-dropdown>
        </div>
      </div> -->

          <div class="col-12 md:col-2">
            <div class="form-field">
              <label class="filter-label" translate>label_assign_driver_duty_status</label>
              <p-select [options]="dutyStatusOptions" [(ngModel)]="selectedDutyStatus" [style]="{'width': '100%'}"
                placeholder="All">
              </p-select>
            </div>
          </div>

          <!-- <div class="col-12 md:col-2">
        <div class="form-field">
          <label class="filter-label" translate>label_sort_by</label>
          <p-dropdown 
            [options]="sortByOptions" 
            [(ngModel)]="selectedSortBy"
            [style]="{'width': '100%'}"
            placeholder="Nearby">
          </p-dropdown>
        </div>
      </div> -->

          <div class="col-12 md:col-10 pb-3" style="align-content: end;">
            <div class="form-field filter-buttons" style="display: flex;justify-content: flex-end;">
              <button pButton type="button" [label]="'label_reset' | translate" class="p-button-outlined reset-btn"
                icon="fa fa-refresh" (click)="onReset()"></button>
              <button pButton type="button" [label]="'label_apply' | translate" class="apply-btn ml-2"
                icon="fa fa-check" (click)="onApply()"></button>
            </div>

          </div>
          <!-- 
      <div class="col-12 md:col-2">
        <div class="form-field filter-buttons">
          <label class="filter-label">&nbsp;</label>
          <button pButton type="button" [label]="'label_apply' | translate" class="apply-btn mt-2" 
            icon="fa fa-check" (click)="onApply()"></button>
        </div>
      </div> -->
        </div>
      </div>

      <!-- Drivers Grid -->
      <app-mi-grid-v2 [columnDefs]="gridColumn" [actionButtonsDefs]="actionButtons" [url]="url" rowSelection="single"
          divClass="mi-grid" (actionBtnClickedEvent)="onActionBtnClicked($event)">
      </app-mi-grid-v2>
    </div>

    <!-- Confirmation Dialog -->
    <p-confirmDialog [header]="'label_confirmation' | translate" icon="fa fa-question-circle" [style]="{width: '425px'}"
      [acceptLabel]="'label_yes' | translate" [rejectLabel]="'label_no' | translate">
    </p-confirmDialog>

    <!-- Rest Period Dialog -->
    <p-dialog [(visible)]="showRestPeriodDialog" [modal]="true" [closable]="false" [draggable]="false"
      [resizable]="false" styleClass="rest-period-dialog" [style]="{width: '400px'}">

      <p-header>
        <div class="dialog-header">
          <span class="dialog-title">{{messageHeaderForAssignDriverPopup}}</span>
        </div>
      </p-header>

      <div class="rest-period-content">
        <p class="rest-period-message">{{messageForAssignDriverPopup}}</p>

        <div class="form-field">
          <label class="reason-label">
            Reason<span class="required-asterisk">*</span>
          </label>
          <textarea [(ngModel)]="restPeriodReason" placeholder="Enter Reason" rows="4" class="reason-textarea"
            pInputTextarea>
        </textarea>
        </div>
      </div>

      <p-footer>
        <div class="dialog-footer">
          <button pButton type="button" label="Cancel" class="cancel-btn" (click)="onCancelRestPeriod()">
          </button>
          <button pButton [disabled]="!restPeriodReason" type="button" label="Assign Anyway" class="assign-anyway-btn"
            (click)="onAssignAnywayClick()">
          </button>
        </div>
      </p-footer>
    </p-dialog>
  </div>
</div>